import React, { forwardRef } from 'react';
import './CirculoRojoCard.css';

interface Props {
  name: string;
  couponCode: string | null;
  firstOrderAt: string | null;
}

const MONTHS_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

function formatMemberSince(iso: string | null): string {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return `${MONTHS_ES[d.getMonth()]} ${d.getFullYear()}`;
  } catch {
    return '—';
  }
}

const CirculoRojoCard = forwardRef<HTMLDivElement, Props>(({ name, couponCode, firstOrderAt }, ref) => {
  const fullName = (name || 'Miembro').trim().replace(/\s+/g, ' ');
  const memberSince = formatMemberSince(firstOrderAt);

  // Escala el nombre según largo para que entre siempre bien en una sola línea.
  // -1px en cada bucket para acomodar nombres largos sin overflow.
  const len = fullName.length;
  const nameSize = len <= 12 ? 79 : len <= 18 ? 63 : len <= 24 ? 51 : 41;

  return (
    <div className="crc-card" ref={ref}>
      <div className="crc-bg" />
      <div className="crc-grain" />
      <div className="crc-content">
        <div className="crc-top">
          <div className="crc-brand">
            <div className="crc-dot" />
            <span className="crc-brand-text">CÍRCULO ROJO</span>
          </div>
          <img src="/logo.png" alt="Krilic" className="crc-logo" />
        </div>

        <div className="crc-middle">
          <div className="crc-middle-text">
            <div className="crc-name" style={{ fontSize: `${nameSize}px` }}>{fullName.toUpperCase()}</div>
            <div className="crc-since">Miembro desde {memberSince}</div>
          </div>
          <div className="crc-chip" aria-hidden="true">
            <div className="crc-chip-grid" />
          </div>
        </div>

        <div className="crc-footer">
          <div className="crc-coupon">
            <div className="crc-coupon-label">TU CUPÓN EXCLUSIVO</div>
            <div className="crc-coupon-code">{couponCode || '—'}</div>
          </div>
        </div>
      </div>
    </div>
  );
});

CirculoRojoCard.displayName = 'CirculoRojoCard';
export default CirculoRojoCard;
